module.exports = __webpack_public_path__ + "static/media/logo.040bb8ff.png";